(function () {
  'use strict';

  if (window.__ryConversionEnhancementsLoaded) return;
  window.__ryConversionEnhancementsLoaded = true;

  var captureShell;

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true);
    } catch (error) {
      return false;
    }
  }

  function track(name, detail) {
    var payload = detail || {};
    try {
      window.dispatchEvent(new CustomEvent('rainbow:' + name, { detail: payload }));
    } catch (error) {}

    if (!analyticsAllowed()) return;

    if (window.RainbowAnalyticsPush) {
      window.RainbowAnalyticsPush(name, Object.assign({ analytics_consent: true }, payload));
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name, analytics_consent: true }, payload));
    }
  }

  function uniqueTags(value) {
    var seen = {};
    return String(value || '')
      .split(',')
      .map(function (tag) { return tag.trim(); })
      .filter(function (tag) {
        var key = tag.toLowerCase();
        if (!tag || seen[key]) return false;
        seen[key] = true;
        return true;
      });
  }

  function mergeTags(current, extra) {
    return uniqueTags([current || '', extra || ''].join(',')).join(',');
  }

  function ensureCapture() {
    if (captureShell && document.documentElement.contains(captureShell)) return captureShell;
    captureShell = document.querySelector('[data-ry-finder-capture-shell]');
    return captureShell;
  }

  function setCaptureData(shell, data) {
    if (!shell || !data) return;
    var form = shell.querySelector('form');
    var tagsField = form && form.querySelector('input[name="contact[tags]"]');
    var title = shell.querySelector('[data-ry-capture-title]');
    var text = shell.querySelector('[data-ry-capture-text]');

    if (tagsField) {
      tagsField.value = mergeTags(
        'newsletter,lead-training-finder,nurture-training-finder,training-finder-completed,training-finder-lead',
        data.tags || ''
      );
    }
    var copyLanguage = data.key === 'spanish' ? 'es' : 'en';
    if (title) title.textContent = shell.getAttribute('data-ry-capture-title-' + copyLanguage) || title.textContent;
    if (text) text.textContent = shell.getAttribute('data-ry-capture-text-' + copyLanguage) || text.textContent;

    shell.hidden = false;
    shell.setAttribute('data-ry-capture-recommendation', data.key || 'unknown');
    track('training_finder_capture_shown', {
      recommendation: data.key || 'unknown',
      source: data.source || 'training_finder'
    });
  }

  function moveAfter(node, reference) {
    if (!node || !reference || !reference.parentNode) return;
    reference.parentNode.insertBefore(node, reference.nextSibling);
  }

  function hideOldEmailLink(scope) {
    if (!scope) return;
    Array.prototype.slice.call(scope.querySelectorAll('a')).forEach(function (link) {
      var label = (link.textContent || '').toLowerCase();
      if (label.indexOf('email me this recommendation') !== -1) {
        link.hidden = true;
        link.style.setProperty('display', 'none', 'important');
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('tabindex', '-1');
      }
    });
  }

  function homepageRecommendation(key) {
    var map = {
      online: {
        key: 'level1',
        title: 'Email me my Level 1 recommendation',
        text: 'We will explain why Level 1 fits, what you learn and how to begin without needing advanced yoga experience.',
        tags: 'finder-recommendation-foundation,finder-recommendation-level1,finder-result-foundation,finder-result-level1',
        source: 'homepage_quiz'
      },
      full: {
        key: 'full',
        title: 'Email me my Full Journey recommendation',
        text: 'We will send the Level 1 + Level 2 pathway, the current comparison and practical guidance for deciding.',
        tags: 'finder-recommendation-complete,finder-recommendation-full,finder-result-complete,finder-result-full',
        source: 'homepage_quiz'
      },
      in_person: {
        key: 'in-person',
        title: 'Email me the current in-person options',
        text: 'We will share the current live-training route and the best online alternative when the dates or city do not fit.',
        tags: 'finder-recommendation-live,finder-recommendation-in-person,finder-result-live,finder-result-in-person',
        source: 'homepage_quiz'
      },
      additional_needs: {
        key: 'inclusive',
        title: 'Email me my inclusive-training recommendation',
        text: 'We will explain the adaptive pathway and how it differs from the Level 1 and Full Journey options.',
        tags: 'finder-recommendation-inclusion,finder-recommendation-specialist,finder-recommendation-additional,finder-result-inclusion,finder-result-additional',
        source: 'homepage_quiz'
      }
    };
    return map[key] || map.online;
  }

  function initHomepageCapture() {
    var quiz = document.querySelector('[data-rainbow-quiz]');
    var result = quiz && quiz.querySelector('[data-rainbow-quiz-result]');
    var shell = ensureCapture();
    if (!quiz || !result || !shell || quiz.dataset.ryCaptureReady === 'true') return;
    quiz.dataset.ryCaptureReady = 'true';

    hideOldEmailLink(result);

    function syncResult() {
      if (result.hidden) return;
      var key = result.getAttribute('data-rainbow-result-key') || 'online';
      var data = homepageRecommendation(key);
      setCaptureData(shell, data);
      var restart = result.querySelector('[data-rainbow-quiz-restart]');
      if (restart && restart.parentNode) restart.parentNode.insertBefore(shell, restart);
      else result.appendChild(shell);
    }

    quiz.addEventListener('click', function (event) {
      if (event.target.closest('[data-rainbow-quiz-restart]')) {
        shell.hidden = true;
        return;
      }
      if (event.target.closest('[data-rainbow-quiz-option]')) {
        window.setTimeout(syncResult, 80);
      }
    });
  }

  function finderRecommendation(key) {
    var map = {
      taste: {
        key: 'taste',
        title: 'Email me the gentle first step',
        text: 'We will send the small introductory option and explain when Level 1 becomes the more useful next step.',
        tags: 'finder-recommendation-taste,finder-result-taste',
        source: 'finder_page'
      },
      level1: {
        key: 'level1',
        title: 'Email me my Level 1 recommendation',
        text: 'We will explain the practical foundation, current format and what happens after enrolment.',
        tags: 'finder-recommendation-foundation,finder-recommendation-level1,finder-result-foundation,finder-result-level1',
        source: 'finder_page'
      },
      full: {
        key: 'full',
        title: 'Email me my Full Journey recommendation',
        text: 'We will send the Level 1 + Level 2 route and the honest comparison with beginning at Level 1 alone.',
        tags: 'finder-recommendation-complete,finder-recommendation-full,finder-result-complete,finder-result-full',
        source: 'finder_page'
      },
      additional: {
        key: 'inclusive',
        title: 'Email me my inclusive-training recommendation',
        text: 'We will explain the adaptive pathway and how it supports choice, dignity and wider participation.',
        tags: 'finder-recommendation-inclusion,finder-recommendation-specialist,finder-recommendation-additional,finder-result-inclusion,finder-result-additional',
        source: 'finder_page'
      },
      support: {
        key: 'support',
        title: 'Email me the supported pathway',
        text: 'We will send the training and mentorship route, including the simpler alternatives when that is the wiser beginning.',
        tags: 'finder-recommendation-support,finder-result-support',
        source: 'finder_page'
      },
      family: {
        key: 'family',
        title: 'Email me the family and classroom options',
        text: 'We will send the practical challenge route and show where teacher training fits when you are ready.',
        tags: 'finder-recommendation-family,finder-result-family',
        source: 'finder_page'
      },
      spanish: {
        key: 'spanish',
        title: 'Envíame mi recomendación en español',
        text: 'Recibirás la ruta online en español y la alternativa presencial actual en Madrid, con orientación clara y sin presión.',
        tags: 'finder-recommendation-spanish,finder-recommendation-spanish-level-1,finder-language-spanish,finder-result-spanish',
        source: 'finder_page_spanish'
      }
    };
    return map[key] || map.level1;
  }

  function addSpanishFinderChoice(root) {
    var buttons = root && root.querySelector('.ry-chooser__buttons');
    if (!buttons || buttons.querySelector('[data-result="spanish"]')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('data-result', 'spanish');
    button.textContent = 'Quiero la formación en español';
    buttons.appendChild(button);
  }

  function renderSpanishFinderResult(result) {
    if (!result) return;
    result.innerHTML = '';

    var label = document.createElement('p');
    label.className = 'ry-chooser__label';
    label.textContent = 'Ruta recomendada';

    var heading = document.createElement('h3');
    heading.textContent = 'La formación online de Nivel 1 en español es tu punto de partida.';

    var copy = document.createElement('p');
    copy.textContent = 'Estudia a tu ritmo desde casa. Si prefieres aprender en vivo, consulta la formación presencial actual en Madrid.';

    var actions = document.createElement('div');
    actions.className = 'ry-finder-page__actions';

    var online = document.createElement('a');
    online.className = 'ry-finder-page__button';
    online.href = '/products/formacion-de-profesores-de-yoga-para-ninos-en-linea-en-espanol';
    online.textContent = 'Explorar Nivel 1 en español';

    var madrid = document.createElement('a');
    madrid.className = 'ry-finder-page__button ry-finder-page__button--light';
    madrid.href = '/products/madrid-october-2026';
    madrid.textContent = 'Ver la formación en Madrid';

    actions.appendChild(online);
    actions.appendChild(madrid);
    result.appendChild(label);
    result.appendChild(heading);
    result.appendChild(copy);
    result.appendChild(actions);
  }

  function initFinderPageCapture() {
    var chooser = document.querySelector('[data-ry-chooser]');
    var result = chooser && chooser.querySelector('[data-ry-result]');
    var shell = ensureCapture();
    if (!chooser || !result || !shell || chooser.dataset.ryCaptureReady === 'true') return;
    chooser.dataset.ryCaptureReady = 'true';
    addSpanishFinderChoice(chooser);

    chooser.addEventListener('click', function (event) {
      var button = event.target.closest('button[data-result]');
      if (!button) return;
      var key = button.getAttribute('data-result') || 'level1';
      var data = finderRecommendation(key);
      window.setTimeout(function () {
        if (key === 'spanish') renderSpanishFinderResult(result);
        setCaptureData(shell, data);
        moveAfter(shell, result);
        track('training_finder_result_selected', { recommendation: data.key, source: data.source });
      }, 80);
    });
  }

  function showCaptureSuccess() {
    var shell = ensureCapture();
    if (!shell || !shell.querySelector('[data-ry-finder-capture-success]')) return;
    var params = new URLSearchParams(window.location.search);
    if (params.get('finder_subscribed') !== '1') return;

    var chooser = document.querySelector('[data-ry-chooser]');
    var homepageFinder = document.querySelector('[data-rainbow-quiz]');
    shell.hidden = false;
    if (chooser) moveAfter(shell, chooser);
    else if (homepageFinder) moveAfter(shell, homepageFinder);
    var success = shell.querySelector('[data-ry-finder-capture-success]');
    if (success && typeof success.focus === 'function') success.focus();
  }

  function addHomepageDecisionFacts() {
    if ((document.body.getAttribute('data-ry-page-type') || '') !== 'index') return;
    var heroCopy = document.querySelector('.ry-hero__copy');
    var lead = heroCopy && heroCopy.querySelector('.ry-lead');
    if (!lead || heroCopy.querySelector('.ry-home-decision-facts')) return;

    var facts = document.createElement('div');
    facts.className = 'ry-home-decision-facts';
    facts.setAttribute('aria-label', 'Training facts');
    [
      ['Start online', 'Begin Level 1 from home when you are ready.'],
      ['Approximately 50 hours', 'A substantial practical foundation.'],
      ['No prior qualification required', 'Caring adults from many backgrounds can begin.'],
      ['Payment support', 'Ask privately before money stops you.']
    ].forEach(function (item) {
      var card = document.createElement('span');
      var strong = document.createElement('strong');
      var copy = document.createElement('em');
      strong.textContent = item[0];
      copy.textContent = item[1];
      card.appendChild(strong);
      card.appendChild(copy);
      facts.appendChild(card);
    });
    moveAfter(facts, lead);
  }

  function installHomepageSticky() {
    if ((document.body.getAttribute('data-ry-page-type') || '') !== 'index') return;
    if (document.querySelector('.ry-home-sticky-finder')) return;

    var bar = document.createElement('div');
    bar.className = 'ry-home-sticky-finder';
    bar.innerHTML = '<div><span>Not sure where to begin?</span><strong>Find the training that fits you</strong></div><a href="/pages/find-my-training" data-ry-cro-event="homepage_sticky_finder">Find My Training</a>';
    document.body.appendChild(bar);

    var blocked = false;
    var observed = document.querySelectorAll('footer, .ry-site-footer, form');
    function sync() {
      bar.classList.toggle('is-visible', window.scrollY > 520 && !blocked);
    }

    if (window.IntersectionObserver) {
      var states = new Map();
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { states.set(entry.target, entry.isIntersecting); });
        blocked = Array.from(states.values()).some(Boolean);
        sync();
      }, { threshold: 0.05 });
      Array.prototype.slice.call(observed).forEach(function (node) { observer.observe(node); });
    }

    window.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  function promoteCourseVideo() {
    var frame = document.querySelector('.ry-video-frame, .ry-product-video, iframe[src*="youtube.com/embed"]');
    if (!frame) return;
    var wrapper = frame.closest('.ry-product-video, .ry-video-frame, .video-wrapper') || frame.parentElement;
    if (wrapper) wrapper.classList.add('ry-course-video-prominent');
  }

  function getAttribution() {
    if (!analyticsAllowed()) return {};
    try {
      return JSON.parse(localStorage.getItem('ry_attribution_v2') || '{}');
    } catch (error) {
      return {};
    }
  }

  function saveAttribution() {
    if (!analyticsAllowed()) return;
    var params = new URLSearchParams(window.location.search);
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
    var incoming = {};
    keys.forEach(function (key) {
      var value = params.get(key);
      if (value) incoming[key] = value.slice(0, 180);
    });
    if (!Object.keys(incoming).length) return;

    var stored = getAttribution();
    stored.first = stored.first || incoming;
    stored.last = incoming;
    stored.landing = stored.landing || window.location.pathname;
    stored.referrer = stored.referrer || document.referrer || '';
    stored.updated_at = new Date().toISOString();
    try { localStorage.setItem('ry_attribution_v2', JSON.stringify(stored)); } catch (error) {}
  }

  function attachAttributionToProductForms() {
    if (!analyticsAllowed()) return;
    var attribution = getAttribution();
    if (!attribution.first && !attribution.last) return;

    Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]')).forEach(function (form) {
      var properties = {
        '_ry_first_source': attribution.first && attribution.first.utm_source,
        '_ry_first_campaign': attribution.first && attribution.first.utm_campaign,
        '_ry_last_source': attribution.last && attribution.last.utm_source,
        '_ry_last_campaign': attribution.last && attribution.last.utm_campaign,
        '_ry_landing': attribution.landing
      };
      Object.keys(properties).forEach(function (key) {
        if (!properties[key] || form.querySelector('input[name="properties[' + key + ']"]')) return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + key + ']';
        input.value = String(properties[key]).slice(0, 180);
        form.appendChild(input);
      });
    });
  }

  function bindTrackedLinks() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-ry-cro-event]');
      if (!trigger) return;
      track(trigger.getAttribute('data-ry-cro-event'), { destination: trigger.href || '' });
    });
  }

  function init() {
    addHomepageDecisionFacts();
    initHomepageCapture();
    initFinderPageCapture();
    showCaptureSuccess();
    installHomepageSticky();
    promoteCourseVideo();
    saveAttribution();
    attachAttributionToProductForms();
    bindTrackedLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    captureShell = null;
    init();
  });
})();
